var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c(
        "v-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSubmitted,
              expression: "!isSubmitted",
            },
          ],
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c("v-container", { attrs: { fluid: "" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 1,
                    expression: "step === 1",
                  },
                ],
              },
              [
                _c("h2", { staticClass: "pb-1 font-weight-regular" }, [
                  _vm._v("Please complete the following information:"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", { staticClass: "asterix" }, [_vm._v("* ")]),
                  _vm._v("indicates required field."),
                ]),
                _vm._v(" "),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "pt-4",
                    model: {
                      value: _vm.form.materialRetrieval,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "materialRetrieval", $$v)
                      },
                      expression: "form.materialRetrieval",
                    },
                  },
                  [
                    [
                      _c("div", [
                        _c("strong", [_vm._v("Choose Pickup or Delivery")]),
                        _c("strong", { staticClass: "asterix" }, [
                          _vm._v(" *"),
                        ]),
                      ]),
                    ],
                    _vm._v(" "),
                    _c("v-radio", {
                      staticClass: "pt-4",
                      attrs: { value: "0" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", [
                                _vm._v(
                                  "Pick Up at a Columbus Metropolitan Library Location"
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("v-radio", {
                      attrs: { value: "1" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [_c("div", [_vm._v("Deliver to School")])]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.materialRetrieval == 0,
                        expression: "form.materialRetrieval == 0",
                      },
                    ],
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        [
                          _c("div", [
                            _c("strong", [_vm._v("Select a Pick-up Location")]),
                            _c("strong", { staticClass: "asterix" }, [
                              _vm._v(" *"),
                            ]),
                          ]),
                        ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.branchLocations,
                            label: "- Select -",
                            outlined: "",
                            rules: _vm.inputDisabled
                              ? []
                              : [_vm.rules.required],
                            disabled: _vm.inputDisabled,
                          },
                          model: {
                            value: _vm.form.pickUpLocation,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "pickUpLocation", $$v)
                            },
                            expression: "form.pickUpLocation",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        [
                          _c("div", [
                            _c("strong", [_vm._v("Choose Pick-up Date")]),
                            _c("strong", { staticClass: "asterix" }, [
                              _vm._v(" *"),
                            ]),
                          ]),
                        ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        _c(
                          "v-menu",
                          {
                            ref: "menu",
                            attrs: {
                              "close-on-content-click": false,
                              "return-value": _vm.date,
                              transition: "scale-transition",
                              "offset-y": "",
                              "min-width": "290px",
                            },
                            on: {
                              "update:returnValue": function ($event) {
                                _vm.date = $event
                              },
                              "update:return-value": function ($event) {
                                _vm.date = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              label: "Choose date",
                                              readonly: "",
                                              outlined: "",
                                              rules: _vm.inputDisabled
                                                ? []
                                                : [_vm.rules.required],
                                              disabled:
                                                _vm.inputDisabled ||
                                                _vm.temporarilyClosed,
                                            },
                                            model: {
                                              value: _vm.form.date,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "date", $$v)
                                              },
                                              expression: "form.date",
                                            },
                                          },
                                          "v-text-field",
                                          attrs,
                                          false
                                        ),
                                        on
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.menu,
                              callback: function ($$v) {
                                _vm.menu = $$v
                              },
                              expression: "menu",
                            },
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-date-picker",
                              {
                                attrs: {
                                  "no-title": "",
                                  scrollable: "",
                                  "allowed-dates": _vm.getAllowedDates,
                                  min: _vm.nowDate,
                                  max: _vm.maxDate,
                                },
                                model: {
                                  value: _vm.form.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "date", $$v)
                                  },
                                  expression: "form.date",
                                },
                              },
                              [
                                _c("v-spacer"),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "", color: "primary" },
                                    on: {
                                      click: function ($event) {
                                        _vm.menu = false
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t    Cancel\n\t\t\t\t\t\t\t    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { text: "", color: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$refs.menu.save(_vm.date)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t    OK\n\t\t\t\t\t\t\t    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.materialRetrieval == "1",
                        expression: "form.materialRetrieval == '1'",
                      },
                    ],
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        [
                          _c("div", [
                            _c("strong", [_vm._v("School Delivery Location")]),
                            _c("strong", { staticClass: "asterix" }, [
                              _vm._v(" *"),
                            ]),
                          ]),
                        ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        [
                          _c("div", { staticClass: "smalltext" }, [
                            _vm._v(
                              "Note: Only available at schools included in the drop-down list."
                            ),
                          ]),
                        ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.deliverSchools,
                            label: "- Select -",
                            outlined: "",
                            rules: !_vm.inputDisabled
                              ? []
                              : [_vm.rules.required],
                            disabled: !_vm.inputDisabled,
                          },
                          model: {
                            value: _vm.form.deliverSchool,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "deliverSchool", $$v)
                            },
                            expression: "form.deliverSchool",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        [
                          _c("div", [
                            _c("strong", [_vm._v("Delivery Month")]),
                            _c("strong", { staticClass: "asterix" }, [
                              _vm._v(" *"),
                            ]),
                          ]),
                        ],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass:
                          "d-flex pl-0 col-12 col-sm-8 col-md-5 col-lg-5",
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.filterDeliverMonth,
                            label: "- Select -",
                            outlined: "",
                            rules: !_vm.inputDisabled
                              ? []
                              : [_vm.rules.required],
                            disabled: !_vm.inputDisabled,
                          },
                          model: {
                            value: _vm.form.deliverMonth,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "deliverMonth", $$v)
                            },
                            expression: "form.deliverMonth",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "tc-button submit-btn",
                    on: {
                      click: function ($event) {
                        return _vm.checkValid(true)
                      },
                    },
                  },
                  [_vm._v("Continue")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "ml-4 tc-button",
                    on: {
                      click: function ($event) {
                        return _vm.cancel()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "pr-1" }, [
                      _vm._v("mdi-close-thick"),
                    ]),
                    _vm._v("Cancel\n\t\t\t\t"),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step == 2,
                    expression: "step==2",
                  },
                ],
              },
              [
                _c(
                  "v-col",
                  {
                    staticClass:
                      "grey lighten-1 rounded pl-0 col-12 col-sm-10 col-md-12 col-lg-12",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "ml-3" },
                      [
                        _c(
                          "h2",
                          { staticClass: "pb-2 pl-6 font-weight-regular" },
                          [_vm._v("Contact Information")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-6 pb-1 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            [
                              _c("div", [
                                _c("strong", [_vm._v("Name:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.form.firstname) +
                                    " " +
                                    _vm._s(_vm.form.lastname)
                                ),
                              ]),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            [
                              _c("div", [
                                _c("strong", [_vm._v("Phone Number")]),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(" *"),
                                ]),
                              ]),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                "background-color": "white",
                                value: _vm.form.phoneNumber,
                                rules: [_vm.rules.required, _vm.rules.phone],
                                type: "tel",
                              },
                              model: {
                                value: _vm.form.phoneNumber,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "phoneNumber", $$v)
                                },
                                expression: "form.phoneNumber",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            [
                              _c("div", [
                                _c("strong", [_vm._v("Mobile Phone Number")]),
                              ]),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                "background-color": "white",
                                value: _vm.form.mobileNumber,
                                rules: [_vm.rules.phone],
                              },
                              model: {
                                value: _vm.form.mobileNumber,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mobileNumber", $$v)
                                },
                                expression: "form.mobileNumber",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            [
                              _c("strong", [_vm._v("Email Address")]),
                              _c("strong", { staticClass: "asterix" }, [
                                _vm._v(" *"),
                              ]),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                "background-color": "white",
                                value: _vm.form.email,
                                rules: [_vm.rules.required, _vm.rules.email],
                              },
                              model: {
                                value: _vm.form.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "email", $$v)
                                },
                                expression: "form.email",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  {
                    staticClass:
                      "d-flex pl-0 col-12 col-sm-10 col-md-12 col-lg-12",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "pl-0 flex" },
                      [
                        _vm.form.deliverSchool
                          ? _c(
                              "v-col",
                              {
                                staticClass:
                                  "d-flex pl-0 pb-3 col-12 col-sm-10 col-md-10 col-lg-10",
                              },
                              [
                                [
                                  _c("div", [
                                    _c("strong", [_vm._v("School:")]),
                                    _vm._v(" " + _vm._s(_vm.setSchool)),
                                  ]),
                                ],
                              ],
                              2
                            )
                          : _c(
                              "div",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass:
                                      "d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                                  },
                                  [
                                    [
                                      _c("div", [
                                        _c("strong", [_vm._v("School")]),
                                        _c(
                                          "strong",
                                          { staticClass: "asterix" },
                                          [_vm._v(" *")]
                                        ),
                                      ]),
                                    ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-col",
                                  {
                                    staticClass:
                                      "d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        value: _vm.form.school,
                                        rules: [_vm.rules.required],
                                      },
                                      model: {
                                        value: _vm.form.school,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "school", $$v)
                                        },
                                        expression: "form.school",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            [
                              _c("div", [
                                _c("strong", [_vm._v("Grade")]),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(" *"),
                                ]),
                              ]),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.grade,
                                label: "- Select -",
                                outlined: "",
                                rules: [_vm.rules.required],
                              },
                              model: {
                                value: _vm.form.grade,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "grade", $$v)
                                },
                                expression: "form.grade",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            [
                              _c("div", [
                                _c("strong", [_vm._v("Reading Level")]),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(" *"),
                                ]),
                              ]),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          {
                            staticClass:
                              "pl-3 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            _c(
                              "v-col",
                              { staticClass: "pl-0" },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "Read Alouds",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.readAloud,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "readAloud", $$v)
                                    },
                                    expression: "form.readAloud",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "Baby (0-18 months)",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.baby,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "baby", $$v)
                                    },
                                    expression: "form.baby",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "Toddler (18-36 months)",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.toddler,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "toddler", $$v)
                                    },
                                    expression: "form.toddler",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "Preschool (3-4 years)",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.preSchool,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "preSchool", $$v)
                                    },
                                    expression: "form.preSchool",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "Pre-Kindergarten (4-5 years)",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.preK,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "preK", $$v)
                                    },
                                    expression: "form.preK",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "Kindergarten",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.kinder,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "kinder", $$v)
                                    },
                                    expression: "form.kinder",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "1st Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.first,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "first", $$v)
                                    },
                                    expression: "form.first",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "2nd Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.second,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "second", $$v)
                                    },
                                    expression: "form.second",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "3rd Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.third,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "third", $$v)
                                    },
                                    expression: "form.third",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { staticClass: "pl-0" },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "4th Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.fourth,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "fourth", $$v)
                                    },
                                    expression: "form.fourth",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "5th Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.fifth,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "fifth", $$v)
                                    },
                                    expression: "form.fifth",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "6th Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.sixth,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "sixth", $$v)
                                    },
                                    expression: "form.sixth",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "7th grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.seventh,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "seventh", $$v)
                                    },
                                    expression: "form.seventh",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "8th Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.eighth,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "eighth", $$v)
                                    },
                                    expression: "form.eighth",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "9th Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.ninth,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "ninth", $$v)
                                    },
                                    expression: "form.ninth",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "10th Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.tenth,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "tenth", $$v)
                                    },
                                    expression: "form.tenth",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "11th Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.eleventh,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "eleventh", $$v)
                                    },
                                    expression: "form.eleventh",
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-checkbox", {
                                  attrs: {
                                    label: "12th Grade",
                                    value: "1",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.form.twelfth,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "twelfth", $$v)
                                    },
                                    expression: "form.twelfth",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            [
                              _c("div", [
                                _c("strong", [_vm._v("Requested Topics")]),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(" *"),
                                ]),
                              ]),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            _c("v-textarea", {
                              attrs: {
                                outlined: "",
                                label: "Requested Topics",
                                value: _vm.form.requestedTopics,
                                rules: [
                                  _vm.rules.required,
                                  _vm.rules.topicsLength,
                                ],
                              },
                              model: {
                                value: _vm.form.requestedTopics,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "requestedTopics", $$v)
                                },
                                expression: "form.requestedTopics",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          {
                            staticClass:
                              "d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10",
                          },
                          [
                            [
                              _c("div", [
                                _c("strong", [
                                  _vm._v("Number of Items Requested"),
                                ]),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(" *"),
                                ]),
                              ]),
                            ],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _c("p", [
                                _vm._v("Print/Audio: "),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(_vm._s(_vm.printAudioTotal)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("v-col", [
                              _c("p", [
                                _vm._v("DVD: "),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(_vm._s(_vm.totalDvd)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("v-col", [
                              _c("p", [
                                _vm._v("Total: "),
                                _c("strong", { staticClass: "asterix" }, [
                                  _vm._v(_vm._s(_vm.totalItems)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c("v-col", { staticClass: "pa-1" }, [
                              _c(
                                "div",
                                { staticClass: "flex grey lighten-1 rounded" },
                                [
                                  _c("div", { staticClass: "pa-1 pt-2" }, [
                                    _c("strong", [_vm._v("Nonfiction")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pa-1" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          "single-line": "",
                                          padding: "1",
                                          "background-color": "white",
                                          label: "nonFiction",
                                          placeholder: "0",
                                          value: _vm.form.nonFiction,
                                          min: "0",
                                          max: "30",
                                          type: "number",
                                        },
                                        model: {
                                          value: _vm.form.nonFiction,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "nonFiction",
                                              $$v
                                            )
                                          },
                                          expression: "form.nonFiction",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-col", { staticClass: "pa-1" }, [
                              _c(
                                "div",
                                { staticClass: "flex grey lighten-1 rounded" },
                                [
                                  _c("div", { staticClass: "pa-1" }, [
                                    _c("strong", [_vm._v("Fiction")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pa-1" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          "single-line": "",
                                          padding: "1",
                                          "background-color": "white",
                                          label: "fiction",
                                          placeholder: "0",
                                          value: _vm.form.fiction,
                                          min: "0",
                                          max: "30",
                                          type: "number",
                                        },
                                        model: {
                                          value: _vm.form.fiction,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "fiction", $$v)
                                          },
                                          expression: "form.fiction",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-col", { staticClass: "pa-1" }, [
                              _c(
                                "div",
                                { staticClass: "flex grey lighten-1 rounded" },
                                [
                                  _c("div", { staticClass: "pa-1" }, [
                                    _c("strong", [_vm._v("Picture Book")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pa-1" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          "single-line": "",
                                          padding: "1",
                                          "background-color": "white",
                                          label: "pictureBook",
                                          placeholder: "0",
                                          value: _vm.form.pictureBook,
                                          min: "0",
                                          max: "30",
                                          type: "number",
                                        },
                                        model: {
                                          value: _vm.form.pictureBook,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "pictureBook",
                                              $$v
                                            )
                                          },
                                          expression: "form.pictureBook",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-col", { staticClass: "pa-1" }, [
                              _c(
                                "div",
                                { staticClass: "flex grey lighten-1 rounded" },
                                [
                                  _c("div", { staticClass: "pa-1" }, [
                                    _c("strong", [_vm._v("Audio")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pa-1" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          "single-line": "",
                                          padding: "1",
                                          "background-color": "white",
                                          label: "audio",
                                          placeholder: "0",
                                          value: _vm.form.audio,
                                          min: "0",
                                          max: "30",
                                          type: "number",
                                        },
                                        model: {
                                          value: _vm.form.audio,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "audio", $$v)
                                          },
                                          expression: "form.audio",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-col", { staticClass: "pa-1" }, [
                              _c(
                                "div",
                                { staticClass: "flex grey lighten-1 rounded" },
                                [
                                  _c("div", { staticClass: "pa-1" }, [
                                    _c("strong", [_vm._v("DVD")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "pa-1" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          "single-line": "",
                                          padding: "1",
                                          "background-color": "white",
                                          label: "dvd",
                                          placeholder: "0",
                                          value: _vm.form.dvd,
                                          min: "0",
                                          max: "5",
                                          type: "number",
                                        },
                                        model: {
                                          value: _vm.form.dvd,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "dvd", $$v)
                                          },
                                          expression: "form.dvd",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-alert",
                          {
                            attrs: {
                              dense: "",
                              outlined: "",
                              value: _vm.alertTriggered,
                              type: "error",
                            },
                          },
                          [
                            _vm._v(
                              "Items are required. Maximum 30 print/audio; 5 DVDs."
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "tc-button submit-btn",
                    attrs: { type: "submit", disabled: _vm.isSubmitting },
                  },
                  [_vm._v("Submit")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "ml-4 tc-button",
                    on: {
                      click: function ($event) {
                        return _vm.cancel()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "pr-1" }, [
                      _vm._v("mdi-close-thick"),
                    ]),
                    _vm._v("Cancel\n\t\t\t\t"),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSubmitted,
              expression: "isSubmitted",
            },
          ],
        },
        [
          _c(
            "v-container",
            { staticClass: "text-center mt-15" },
            [
              _c("h2", { staticClass: "mb-5" }, [
                _vm._v("Your request has been successfully submitted."),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "tc-button submit-btn",
                  attrs: { href: _vm.cmlUrl },
                },
                [_vm._v("Finish")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }